import classNames from "classnames";
import React from "react";

export interface HeaderProps {
  title: string | React.ReactNode;
  logo: string;
  className?: string;
}

export function Header({ logo, className }: HeaderProps) {
  const classes = classNames(
    "navbar",
    "navbar-fixed-top",
    "pb-3",
    "pt-0",
    className
  );
  return (
    <header className={classes}>
      <div className="container-fluid w-100">
        <div className="navbar-header d-flex align-items-center w-100">
          <a className="navbar-brand d-block" href="/">
            <img src={logo} style={{ width: "120px", height: "auto" }} />
          </a>
          {/* <div className="navbar-brand d-block ms-auto">
            <img
              src={
                import.meta.env.BASE_URL + "/webrtc-logo-horiz-retro-dist.svg"
              }
              style={{ width: "200px", height: "auto" }}
            />
          </div> */}
        </div>
      </div>
    </header>
  );
}
